var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessaging = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#6780AA",
  fillRule: "evenodd",
  d: "M22.27 15.27v-2.52h-2.52v2.52zm-5.04 0v-2.52h-2.46v2.52zm-4.98 0v-2.52H9.73v2.52zM26.02 4.02q1.02 0 1.74.72c.72.72.72 1.06.72 1.74v15q0 1.02-.72 1.77c-.72.75-1.06.75-1.74.75H8.5l-4.98 4.98V6.48q0-1.02.72-1.74a2.37 2.37 0 0 1 1.74-.72z"
})));
export default SvgMessaging;